<template>
  <v-card flat>
    <v-card-text>
      <v-row class="mb-4">
        <v-col cols="12" sm="6" md="4">
          <v-select
            v-model="especialidadFiltro"
            :items="especialidadesDisponibles"
            label="Filtrar por Especialidad"
            prepend-icon="mdi-medical-bag"
            clearable
            outlined
            dense
            color="primary"
            @change="filtrarProfesionales"
          ></v-select>
        </v-col>
      </v-row>

      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        class="mb-4"
      ></v-progress-linear>

      <v-row v-if="!loading && profesionalesFiltrados.length > 0">
        <v-col
          v-for="profesional in profesionalesFiltrados"
          :key="profesional.idProfesional"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-card
            class="professional-card d-flex flex-column"
            elevation="4"
            hover
          >
            <!-- Foto del profesional -->
            <v-img
              :src="
                profesional.foto ||
                'https://api.sigemed.com.ar/profesionales/nophoto.jpg'
              "
              height="160"
              class="professional-image"
            >
            </v-img>

            <v-divider></v-divider>

            <!-- Nombre con color -->
            <v-card-title class="py-2 px-3 teal lighten-1 white--text">
              <v-icon left color="white" small>mdi-doctor</v-icon>
              <span class="text-subtitle-2 font-weight-bold professional-name">
                {{ profesional.nombre }}
              </span>
            </v-card-title>

            <v-divider></v-divider>

            <!-- Contenido con altura fija -->
            <v-card-text
              class="flex-grow-1 d-flex flex-column pt-2 pb-2 px-3 card-content"
            >
              <div class="info-section">
                <div class="mb-2 text-center">
                  <v-chip
                    color="primary"
                    label
                    outlined
                    small
                    class="mb-1 specialty-chip"
                  >
                    <v-icon left small>mdi-medical-bag</v-icon>
                    <span class="font-weight-medium">
                      {{ profesional.especialidad || "No especificada" }}
                    </span>
                  </v-chip>
                </div>

                <div v-if="profesional.matricula" class="mb-2">
                  <div class="d-flex align-center">
                    <v-icon x-small color="primary" class="mr-1">
                      mdi-card-account-details
                    </v-icon>
                    <span class="text-caption">
                      <strong>Mat:</strong> {{ profesional.matricula }}
                    </span>
                  </div>
                </div>

                <div class="observaciones-container">
                  <v-alert
                    v-if="profesional.observaciones"
                    color="info"
                    text
                    dense
                    class="mb-0 pa-2 text-center"
                    icon="mdi-information"
                  >
                    <div class="text-caption">
                      {{ profesional.observaciones }}
                    </div>
                  </v-alert>
                </div>

                <div
                  v-if="profesional.precioConsultaString"
                  class="mt-2 text-center"
                >
                  <v-chip
                    color="red"
                    label
                    outlined
                    small
                    class="font-weight-bold"
                  >
                    <v-icon left small>mdi-currency-usd</v-icon>
                    Valor: {{ profesional.precioConsultaString }}
                  </v-chip>
                </div>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="pa-2">
              <v-btn
                color="success"
                @click="seleccionar(profesional)"
                block
                elevation="2"
                small
              >
                <v-icon left small>mdi-calendar-check</v-icon>
                Seleccionar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-alert
        v-if="
          !loading &&
          profesionalesFiltrados.length === 0 &&
          profesionales.length > 0
        "
        color="orange"
        dark
        outlined
        class="mt-4"
      >
        <v-icon left>mdi-filter-off</v-icon>
        No se encontraron profesionales con la especialidad seleccionada
      </v-alert>

      <v-alert
        v-if="!loading && profesionales.length === 0"
        color="blue"
        dark
        outlined
        class="mt-4"
      >
        <v-icon left>mdi-account-off</v-icon>
        No se encontraron profesionales disponibles para la obra social
        seleccionada
      </v-alert>

      <v-row class="mt-4">
        <v-col cols="12" sm="auto">
          <v-btn color="primary" outlined @click="$emit('volver')" block>
            <v-icon left>mdi-arrow-left</v-icon>
            Volver
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.professional-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
  height: 100%;
}

.professional-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;
}

.professional-image {
  position: relative;
}

.professional-name {
  line-height: 1.2;
  word-break: break-word;
}

.specialty-chip {
  width: 100%;
  justify-content: center;
  height: auto !important;
  min-height: 28px;
  padding: 4px 8px;
}

.specialty-chip .v-chip__content {
  width: 100%;
  justify-content: center;
}

.card-content {
  min-height: 150px;
  max-height: 150px;
}

.info-section {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.observaciones-container {
  flex-grow: 1;
  overflow-y: auto;
  max-height: 70px;
}

/* Scrollbar personalizado para observaciones */
.observaciones-container::-webkit-scrollbar {
  width: 3px;
}

.observaciones-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.observaciones-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.observaciones-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .card-content {
    min-height: 140px;
    max-height: 140px;
  }

  .observaciones-container {
    max-height: 60px;
  }

  .professional-name {
    font-size: 0.85rem;
  }
}

@media (max-width: 400px) {
  .card-content {
    min-height: 130px;
    max-height: 130px;
  }

  .observaciones-container {
    max-height: 50px;
  }

  .professional-name {
    font-size: 0.8rem;
  }
}
</style>

<script>
import axios from "../axios-auth.js";

export default {
  name: "BuscarProfesional",
  props: {
    idObraSocial: {
      type: Number,
      required: true,
    },
    tipoDeTurno: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      profesionales: [],
      profesionalesFiltrados: [],
      especialidadFiltro: null,
      loading: false,
    };
  },
  computed: {
    especialidadesDisponibles() {
      const especialidades = [
        { text: "TODAS", value: null },
        ...new Set(
          this.profesionales
            .map((p) => p.especialidad)
            .filter((e) => e && e.trim() !== ""),
        ),
      ].map((e) => (typeof e === "string" ? { text: e, value: e } : e));

      return especialidades;
    },
  },
  watch: {
    idObraSocial() {
      this.buscarProfesionales();
    },
  },
  mounted() {
    this.buscarProfesionales();
  },
  methods: {
    buscarProfesionales() {
      this.loading = true;
      this.especialidadFiltro = null;
      axios
        .get("/PortalPublico/GetProfInstDispWeb", {
          params: {
            idInstitucion: this.$store.state.idInstitucion,
            idObraSocial: this.idObraSocial,
          },
        })
        .then((response) => {
          this.profesionales = response.data;
          this.profesionalesFiltrados = response.data;
        })
        .catch((error) => {
          console.error("Error al buscar profesionales:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filtrarProfesionales() {
      if (!this.especialidadFiltro) {
        this.profesionalesFiltrados = this.profesionales;
      } else {
        this.profesionalesFiltrados = this.profesionales.filter(
          (p) => p.especialidad === this.especialidadFiltro,
        );
      }
    },
    seleccionar(profesional) {
      this.$emit("profesionalSeleccionado", profesional);
    },
  },
};
</script>
